<template>
  <div style="margin: 0px 30px" class="report-15" dir="rtl">
    <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div> -->

    <h3 style="margin-bottom: 15px" class="text-center">{{ fullName }}</h3>
    <h3 style="margin-top: 0px" class="text-center">
      {{ shortName }}
    </h3>

    <h3
      style="font-weight: bold; padding-bottom: 40px; padding-top: 20px"
      class="text-center"
    >
      تقرير بأعداد الموظفين حسب الادارة
    </h3>

    <div class="md-layout-item md-size-100 mt-25">
      <h4 style="font-weight: bold" class="text-center"></h4>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header
            style="margin-bottom: 30px"
            class="md-card-header-text md-card-header-green"
          >
            <div class="card-text">
              <h4 class="title">تقرير بأعداد الموظفين حسب الادارة</h4>
            </div>
          </md-card-header>
          <form>
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-30 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>التاريخ</label>
                    <md-input disabled v-model="date"></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </form>

          <div style="margin-top: 10px; margin-bottom: 35px" class="marginTop">
            <md-card-content>
              <md-table class="paginated-table table-striped table-hover mt-25">
                <md-table-row>
                  <md-table-cell>ر.م</md-table-cell>

                  <md-table-cell>الادارة</md-table-cell>

                  <md-table-cell>عدد الموظفين</md-table-cell>
                </md-table-row>
                <md-table-row v-for="(item, i) in allData" :key="i">
                  <md-table-cell md-label="الصنف">{{ i + 1 }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.department
                  }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.headCount
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
          <div
            style="margin-bottom: 30px; margin-right: 20px"
            class="md-layout"
          >
            <div class="md-layout-item md-size-30 ml-15">
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <label>المجموع</label>
                <md-input disabled v-model="total"></md-input>
              </md-field>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>
  
<script>
import env from "../../../env";

export default {
  props: [
    "allData",
    "fullName",
    "shortName",
    "Days",
    "monthDate",
    "total",
    "date",
  ],
  data() {
    return {
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
  },
};
</script>
  
<style lang="scss" scoped>
@import "../../assets/css/Staff_preparation";
</style>
  